import { defineComponent as _defineComponent } from 'vue'
import router from "@/router";
import { auth0 } from "@/services/auth.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'auth-callback',
  setup(__props, { expose: __expose }) {
  __expose();

auth0.handleRedirectCallback()
  .then(() => {
    // Redirect the user to the home page after authentication
    router.push({ name: "Home" });
  });


const __returned__ = { get auth0() { return auth0 } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})